<template>
    <div v-loading="loading">
        <!-- 上部：筛选区域 -->
        <div class="filter-section">
            <el-date-picker v-model="startDate" type="date" placeholder="选择计划开始日期"></el-date-picker>
            <el-date-picker v-model="endDate" type="date" placeholder="选择计划结束日期"></el-date-picker>
            <el-select v-model="department" clearable placeholder="选择部门">
                <el-option v-for="item in options" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
            </el-select>
            <el-button type="primary" size="small" icon="el-icon-search" @click="fetchData">{{ '搜索' }}</el-button>
        </div>
        <div style="height: 6px; background: #ebebeb"></div>
        <!-- 下部：统计区域 -->
        <div class="stats-content">
            <div class="stat-item" v-for="(item, index) in stats" :key="index" :class="item.class">
                <div class="stat-title">{{ item.title }}</div>
                <div class="stat-value">{{ item.value }}</div>
            </div>

            <div class="stat-item">
                <div class="circle-container">
                    <svg viewBox="0 0 120 120" class="circle-svg">
                        <circle class="circle-bg" cx="60" cy="60" r="50" />
                        <circle class="circle-progress" cx="60" cy="60" r="50" :stroke-dasharray="circlePerimeter"
                            :stroke-dashoffset="circleOffset" />
                    </svg>
                    <div class="circle-text">
                        <div class="label">{{ '完成率' }}</div>
                        <div class="rate">
                            {{ completionRate }}<span class="percent">%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style="height: 6px; background: #ebebeb"></div>
        <div style="margin:  5px 10px 0 10px;">
            <vxe-toolbar ref="xToolbar" custom print export>
            </vxe-toolbar>
            <vxe-table border height="580" show-overflow align="center" resizable ref="table" :print-config="{}"
                :row-config="{ height: 36 }" :toolbar-config="tableToolbar" :data="tableData">
                <vxe-column type="seq" title="序号" width="60"></vxe-column>
                <vxe-column field="userName" title="成员"></vxe-column>
                <vxe-column field="total" title="总任务"></vxe-column>
                <vxe-column field="notStart" title="未开始"></vxe-column>
                <vxe-column field="inProgress" title="进行中">
                    <template #default="{ row }">
                        <span style="color: #FFC647">{{ row.inProgress }}</span>
                    </template>
                </vxe-column>
                <vxe-column field="complete" title="已完成">
                    <template #default="{ row }">
                        <span style="color: #3ED1AE">{{ row.complete }}</span>
                    </template>
                </vxe-column>
                <vxe-column field="finishingRate" title="完成率">
                    <template #default="{ row }">
                        <el-progress :percentage="Number(row.finishingRate)" :stroke-width="10" color="#3ED1AE" />
                    </template>
                </vxe-column>
            </vxe-table>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            loading: false,
            completionRate: 0,
            statsData: {
                memberCount: 0,
                totalTasks: 0,
                notStarted: 0,
                inProgress: 0,
                completed: 0
            },
            tableData: [],
            dynamicColumns: [],
            tableToolbar: {
                print: true,
                export: true,
                zoom: true,
                custom: true,
                slots: {
                    tools: "tools",
                },
            },
            rowStyle: { cursor: "pointer" },
            options: [],
            department: '',
            startDate: '',
            endDate: '',
        };
    },
    props: {},
    computed: {
        stats() {
            return [
                { title: '成员', value: this.statsData.memberCount },
                { title: '总任务', value: this.statsData.totalTasks },
                { title: '未开始', value: this.statsData.notStarted },
                {
                    title: '进行中',
                    value: this.statsData.inProgress,
                    class: 'stat-inprogress'
                },
                {
                    title: '已完成',
                    value: this.statsData.completed,
                    class: 'stat-completed'
                }
            ]
        },
        circlePerimeter() {
            return 2 * Math.PI * 50;
        },
        circleOffset() {
            return this.circlePerimeter * (1 - this.completionRate / 100);
        },
    },
    created() {
        this.getClassAttributeProperties()
    },
    methods: {
        async getClassAttributeProperties() {
            try {
                const params = {
                    clsId: 90101,
                    tableId: 1,
                    attributeId: 1090022
                };
                const url = `/pmdm/admin/cls/getClassAttributeProperties?${new URLSearchParams(params)}`;

                const response = await axios.get(url);

                if (response.data?.code === 200) {
                    const { properties = [] } = response.data.object || {};

                    const targetProperty = properties.find(i => i.id === 1900637);

                    if (targetProperty?.propertyValue !== undefined) {
                        this.getDefaultValList(targetProperty.propertyValue);
                    } else {
                        console.warn('Target property not found or propertyValue is undefined');
                    }
                }
            } catch (error) {
                console.error('Failed to fetch class attributes:', error);
            }
        },
        async getDefaultValList(num) {
            // 参数校验
            if (!num) {
                console.warn('Invalid listId parameter');
                return;
            }

            try {
                const params = new URLSearchParams({ listId: num });
                const response = await axios.get(`pmdm/admin/list/retriveListEntries?${params}`);

                if (response.data?.code !== 200) {
                    throw new Error(`Request failed with status ${response.data.code}`);
                }

                const data = response.data?.object;
                if (!data) {
                    throw new Error('Invalid response data structure');
                }

                this.options = Object.entries(data).map(([value, label]) => ({
                    value,
                    label
                }));

                return true;
            } catch (error) {
                console.error('Failed to fetch list entries:', error);
                this.options = [];
                return;
            }
        },
        async fetchData() {
            try {
                this.loading = true;
                const dateVerification = this.validateDateRange();
                if (dateVerification) {
                    this.$message({
                        showClose: true,
                        message: '警告，计划结束日期不能早于计划开始日期！',
                        type: 'warning'
                    });
                    return;
                }
                const payload = {
                    startDate: this.processDate(this.startDate),
                    endDate: this.processDate(this.endDate),
                    department: this.department
                };
                const { data } = await axios.post('/ppm/projectBoard/buildProjectProgressReport', payload);
                if (data.code !== 200 || !data.object) {
                    throw new Error(`请求失败: ${data.code}`);
                }
                const { total = {}, userTotalList = [] } = data.object;

                this.statsData = {
                    memberCount: Number(total.userName) || 0,
                    totalTasks: total.total ?? 0,
                    notStarted: total.notStart ?? 0,
                    inProgress: total.inProgress ?? 0,
                    completed: total.complete ?? 0
                };

                this.completionRate = total.finishingRate || '0';
                this.tableData = userTotalList;
            } catch (error) {
                console.error('数据获取失败:', error)
            } finally {
                this.loading = false;
            }
        },
        processDate(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        validateDateRange() {
            if (!this.startDate || !this.endDate) return false;
            const getYMD = date => date.getFullYear() * 10000 + (date.getMonth() + 1) * 100 + date.getDate();
            const isValid = getYMD(new Date(this.endDate)) < getYMD(new Date(this.startDate));
            if (!isValid) {
                return false;
            }
            return true;
        },
        inProgressCellClass() {
            return 'in-progress-cell'
        },
        completeCellClass() {
            return 'complete-cell'
        }
    }
};
</script>

<style scoped>
.filter-section {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    padding: 5px;
    border-bottom: none;
}

.stats-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 0;
}

.stat-item {
    text-align: center;
    flex: 1;
    border-right: 1px solid #f0f0f0;
    padding: 0 15px;
}

.stat-item:last-child {
    border-right: none;
    flex: 0 0 auto;
}

.stat-title {
    color: #999;
    font-size: 16px;
    margin-bottom: 14px;
}

.stat-value {
    font-size: 24px;
    font-weight: 600;
    color: #333;
}

.stat-inprogress .stat-value {
    color: #FFC647;
}

.stat-completed .stat-value {
    color: #3ED1AE;
}

.circle-container {
    position: relative;
    width: 120px;
    height: 120px;
    margin: 0 auto;
}

.circle-svg {
    transform: rotate(-90deg);
    width: 120px;
    height: 120px;
}

.circle-bg {
    fill: none;
    stroke: #eee;
    stroke-width: 10;
}

.circle-progress {
    fill: none;
    stroke: #00c9a7;
    stroke-width: 10;
    stroke-linecap: round;
    transition: stroke-dashoffset 0.6s ease;
}

.circle-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

.label {
    color: #999;
    font-size: 14px;
}

.rate {
    font-size: 22px;
    color: #00c9a7;
    font-weight: bold;
    margin-left: 10px;
}

.percent {
    font-size: 14px;
    margin-left: 2px;
}

:deep(.el-progress__text) {
    width: 52px;
}
</style>